(function ($) {
  var $ = jQuery = $;

  $(document).on('click', 'remove-item', function(){
    const sku = $(this).data('sku')
    let itemsToRemove = {}

    document.querySelectorAll(`.cart-item[data-sku="${sku}"]`).forEach((item)=>{
        itemsToRemove[item.dataset.key] = 0
    })

    // Send a single request to batch-remove the items
    fetch(theme.routes.cart_update_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: itemsToRemove })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cart => {
        document.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
        );
    })
    .catch(error => {
        console.error('Error removing multiple items:', error);
    });
  })

  $(document).on('theme:cartchanged', function (event) {
      $.get(`${theme.routes.cart_url}.js`, function(data) {
        const cart = JSON.parse(data)
        let candidates = []
        let qty = 0
        if(cart.item_count > 0) {
            cart.items.forEach((item)=>{
                console.log(item)
                if(item.discounts.length == 0) {
                    candidates.push({
                        'key': item.key,
                        'qty': item.quantity
                    })
                    qty+= item.quantity
                }
            })
            console.log(qty)
            console.log(candidates)
/*
            if(qty > 2 && candidates.length > 0) {
                console.log('reduce')
                let increment = candidates.length == 1 ? 2 : 1
                let updates = {}
                candidates.forEach((candidate)=>{
                    updates[`${candidate.key}`] = candidate.qty - increment
                })
                fetch(theme.routes.cart_update_url, {
                    method: 'POST',
                    body: JSON.stringify({ updates }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    if (!response.ok) {
                        throw new Error("HTTP error! Status: ".concat(response.status));
                    }
                    document.dispatchEvent(
                        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
                    );
                });
            } else 
                */
            if(qty == 2 && candidates.length > 0) {
                let increment = candidates.length == 1 ? 2 : 1
                let updates = {}
                candidates.forEach((candidate)=>{
                    updates[`${candidate.key}`] = candidate.qty + increment
                })
                console.log(updates)
                fetch(theme.routes.cart_update_url, {
                    method: 'POST',
                    body: JSON.stringify({ updates }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    if (!response.ok) {
                        throw new Error("HTTP error! Status: ".concat(response.status));
                    }
                    document.dispatchEvent(
                        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
                    );
                });
            }
        }
      })
  })

})(theme.jQuery);